// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__SM7BH","text":"Profile_text__o-u8M","email":"Profile_email__+HdPj","editableSpan":"Profile_editableSpan__DkDik"};